import { Component, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';

declare var $: any;
//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: 'dashboard',
    title: 'Inicio',
    type: 'link',
    icontype: 'pe-7s-home'
}, {
    path: 'calendar',
    title: 'Reservas',
    type: 'link',
    icontype: 'pe-7s-date'
}, {
    path: 'document',
    title: 'Documentos',
    type: 'link',
    icontype: 'pe-7s-news-paper'
}, {
    path: 'book',
    title: 'Livro de Ocorrências',
    type: 'link',
    icontype: 'pe-7s-notebook'
}, {
    path: 'provider',
    title: 'Fornecedores',
    type: 'link',
    icontype: 'pe-7s-id'
}, {
    path: 'employee',
    title: 'Funcionarios',
    type: 'link',
    icontype: 'pe-7s-users'
}, {
    path: 'sales',
    title: 'Classificados',
    type: 'link',
    icontype: 'pe-7s-ticket'
}, {
    path: 'common',
    title: 'Areas Comum',
    type: 'link',
    icontype: 'pe-7s-way'
}, {
    path: 'setting',
    title: 'Configuração',
    type: 'sub',
    icontype: 'pe-7s-tools',
    children: [
        { path: 'general', title: 'Geral', ab: 'GE' },
        { path: 'contract', title: 'Contrato', ab: 'CO' },
        { path: 'payment', title: 'Pagamento', ab: 'PA' },
        { path: 'approval', title: 'Aprovar Usuario', ab: 'AU' }
    ]
}
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent {
    public menuItems: any[];
    isNotMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        this.menuItems = ROUTES.filter(menuItem => menuItem);

        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
            $('html').addClass('perfect-scrollbar-on');
        } else {
            $('html').addClass('perfect-scrollbar-off');
        }
    }
    ngAfterViewInit() {
        var $sidebarParent = $('.sidebar .nav > li.active .collapse li.active > a').parent().parent().parent();

        var collapseId = $sidebarParent.siblings('a').attr("href");

        $(collapseId).collapse("show");
    }
}
